/* eslint-disable import/prefer-default-export */
/* eslint-disable linebreak-style */
import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  app: {
    display: "flex",
    width: "100vw",
    height: "100vh",
    minHeight: 500,
    minWidth: 320,
    overflow: "hidden",
    padding: 0,
    margin: 0,
  },
  gap10: {
    gap: 10,
  },
  loginBox: {
    width: "25%",
    height: "auto",
    // border: '1px solid black',
    display: "inherit",
  },
  loginBox1: {
    height: "auto",
    justifyContent: "center",
    width: "450px",
  },
  heading1: {
    fontSize: "40px",
    fontWeight: "bold",
    fontFamily: "Tomica",
    fontStyle: "normal",
    lineHeight: "51px",
    alignItems: "left",
  },
  heading2: {
    fontSize: "20px",
    // fontWeight: 'bold',
    fontFamily: "Tomica",
    fontStyle: "normal",
    lineHeight: "51px",
    marginLeft: "10px",
    paddingTop: "2px",
  },
  error: {
    fontSize: "16px",
    // fontWeight: 'bold',
    // fontFamily: 'Circular Std',
    fontStyle: "normal",
    lineHeight: "51px",
    color: "red",
    fontWeight: "bold",
    marginLeft: "0px",
    marginTop: "0px",
  },
  heading3: {
    fontSize: "28px",
    fontWeight: "bold",
    // fontFamily: 'Circular Std',
    fontStyle: "normal",
    lineHeight: "51px",
  },
  heading4: {
    fontSize: "18px",
    fontWeight: "bold",
    // fontFamily: 'Circular Std',
    fontStyle: "normal",
    lineHeight: "28px",
    marginTop: "2vh",
    marginBottom: "3vh",
  },
  displayFlex: {
    display: "flex",
  },
  displayFlex1: {
    display: "flex",
    justifyContent: "center",
  },
  width100: {
    width: "100%",
  },
  loginForm: {
    paddingTop: "10px",
    width: "40%",
    maxWidth: "400px",
    minWidth: "300px",
  },
  inputHeight: {
    "& input": {
      height: "1vh",
    },
    "&::placeholder": {
      color: "#ffff",
      lineHeight: "18px",
      fontWeight: "540",
      fontSize: "14px",
      opacity: 1,
    },
  },
  marginTop: {
    marginTop: "20px",
  },
  loginBtn: {
    top: "20px",
    color: "white",
    height: "40px",
    background: `var(--color-primary)`,
  },
  otpInput: {
    marginRight: "25px",
    height: "45px",
    width: "60px !important",
    marginTop: "20px",
    border: "1px solid #CCCCCC",
    borderRadius: "4px",
  },
  otpInput1: {
    marginRight: "25px",
    height: "40px",
    width: "50px !important",
    marginTop: "20px",
    border: "1px solid #CCCCCC",
    borderRadius: "4px",
  },
  errorText: {
    color: "red",
    marginTop: "1vh",
    marginBottom: "-2vh",
  },
  placeHolder: {
    "&::placeholder": {
      color: "#606060",
      lineHeight: "18px",
      fontWeight: "540",
      fontSize: "14px",
      opacity: 1,
    },
  },
  "@media screen and (max-width: 768px)": {
    loginBox: {
      width: "85%",
    },
    otpInput: {
      marginRight: "20px",
      height: "2.9em",
      width: "3em !important",
      marginTop: "20px",
    },
  },
  "@media screen and (max-width: 1024px)": {
    loginBox1: {
      padding: "30px",
    },
    otpInput: {
      marginRight: "20px",
      height: "3em",
      width: "2.4em !important",
      marginTop: "20px",
    },
  },
  "@media screen and (width: 768px)": {
    otpInput: {
      marginRight: "20px",
      height: "3em",
      width: "2.9em !important",
      marginTop: "20px",
    },
  },
  splitContainer: {
    display: "flex",
    width: "100vw",
    height: "100vh",
    minHeight: 500,
    minWidth: 320,
    boxShadow: "none",
    borderRadius: 0,
    background: "none",
    overflow: "hidden",
  },
  leftImageSection: {
    width: "43vw",
    height: "100vh",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  leftImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 1,
  },
  leftOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    textAlign: "center",
  },
  leftOverlayLogo: {
    width: "160px",
    height: "60px",
    marginBottom: 24,
    objectFit: "cover",
  },
  leftOverlayLogoGuild: {
    width: "300px",
    marginBottom: 24,
    objectFit: "cover",
  },
  leftOverlayTitle: {
    fontSize: 36,
    fontWeight: 700,
    marginBottom: 8,
    letterSpacing: 1,
  },
  leftOverlaySubtitle: {
    fontSize: 18,
    fontWeight: 400,
    marginBottom: 24,
    letterSpacing: 0.5,
  },
  leftOverlayDesc: {
    fontSize: 16,
    fontWeight: 300,
    lineHeight: 1.5,
    maxWidth: 400,
    margin: "0 auto",
  },
  rightFormSection: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "#fff",
  },
});
